import React, { useState, useEffect } from "react";
import { DeleteCustomerProps } from "./DeleteCustomer.types";
import { useDeleteCustomer } from "./useDeleteCustomer";
import ConfirmDialog from "../../../../components/genericform/ConfirmDialog";
import "react-toastify/dist/ReactToastify.css";

const DeleteCustomer: React.FC<DeleteCustomerProps> = ({ id, name, outStandingBalance, refreshCustomerList, onClose }) => {
  const [open, setOpen] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);

  const { isDeleting, isDeleted, handleDelete } = useDeleteCustomer({
    id,
    outStandingBalance,
    refreshCustomerList,
    onClose: () => {
      setOpen(false);
      setTimeout(() => {
        setShouldRender(false);
        onClose?.();
      }, 2900);
    },
  });

  useEffect(() => {
    if (isDeleted) {
      setOpen(false);
    }
  }, [isDeleted]);

  if (!shouldRender) return null;

  return (
    <>
      <ConfirmDialog
        open={open}
        title="Delete Confirmation"
        description={
          Number(outStandingBalance) > 0
            ? `This customer has an outstanding balance of ₹${outStandingBalance}. Please clear the balance before deleting the customer.`
            : `Are you sure you want to delete customer "${name}"? This action cannot be undone.`
        }
        confirmLabel={isDeleting ? "Deleting..." : "Confirm"}
        cancelLabel="Cancel"
        isProcessing={isDeleting}
        disableConfirm={Number(outStandingBalance) > 0}
        onConfirm={handleDelete}
        onCancel={() => {
          setOpen(false);
          setShouldRender(false);
          onClose?.();
        }}
      />
    </>
  );
};

export default DeleteCustomer;
